import { ACCOUNTS_WITH_SIGNALS_COLUMN } from "../configuration/table-columns/columnNames";
import type { TableColumnName } from "app/pages/sales-intelligence/pages/home/types/table";

export const getSignalId = (getByField: TableColumnName): string | undefined => {
    const fieldToSignalMap: Record<string, string> = {
        [ACCOUNTS_WITH_SIGNALS_COLUMN]: "any",
    };

    return fieldToSignalMap[getByField];
};
